import { Injectable, inject } from '@angular/core';

import { ClientConfigDBService } from '../db/client-config-db-service';
import { Resolve } from '@angular/router';
import { PointToCategoryMappingConfig } from '@core/api';

@Injectable()
export class PointToCategoryMappingConfigResolver implements Resolve<PointToCategoryMappingConfig> {
  private clientConfigDbService = inject(ClientConfigDBService);

  public resolve() {
    return this.clientConfigDbService.getPointToCategoryMappingConfig();
  }
}
